<template>
    <div class="mobile-buttons">
        <button data-sms class="btn" :class="buttonClass" :data-contacts='phonesObj'>
            <div v-if="isDS" id="menu-btn-texture">&nbsp;</div>
            <div class="contact-icon">
                <span class="fa fa-mobile-phone"></span>
            </div>
            <strong class="btn-text">Text</strong>
            <span class="fa fa-ellipsis-h indicator"></span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'Sms',
    props: {
        phones: { type: Array, required: true },
        isDS: { type: Boolean, required: false }
    },
    computed: {
        phonesObj () {
            return JSON.stringify(this.phones);
        },
        buttonClass () {
            return this.isDS
                ? 'btn-primary'
                : 'btn-warning btn-lg';
        }
    }
};
</script>

<style scoped>

</style>
